import { gql } from '@apollo/client';

const Word = gql`
  fragment Word on Word {
    usageCounter
    wordProperty {
      wordPropertyId
      word
      transcription
      definition
      example
      example2
      example3
      audio { path }
      exampleAudio { path }
      example2Audio { path }
      example3Audio { path }
    }
    translationProperty {
      translation
      audio { path }
    }
    images {
      path
      size
    }
  }
`;

const Phrase = gql`
  fragment Phrase on Phrase {
    audio { path }
    wordPropertyId
    word
    definition
    example
    example2
    example3
    wordType
  }
`;

const Synonym = gql`
  fragment Synonym on Synonym {
    wordProperty {
      wordPropertyId
      word
    }
    synonym {
      wordPropertyId
      word
      transcription
      audio { path }
    }
  }
`;

export default {
  Word,
  Phrase,
  Synonym,
};
